import Main from "../components/Main";

function index() {
  return <Main />;
}

export default index;
